// Canonical RBAC roles for the frontend.
// Mirror of backend/src/auth/roles.js — keep in sync.

export const ROLE_OPTIONS = [
  { value: 'admin', label: 'ADMIN' },
  { value: 'project_manager', label: 'PROJECT MANAGER' },
  { value: 'site_manager', label: 'SITE MANAGER' },
  { value: 'site_engineer', label: 'SITE ENGINEER' },
  { value: 'commercial_manager', label: 'COMMERCIAL MANAGER' },
  { value: 'commercial_staff', label: 'COMMERCIAL STAFF' },
  { value: 'customer', label: 'CUSTOMER' },
  { value: 'staff', label: 'STAFF' },
  { value: 'procurement_ho_manager', label: 'PROCUREMENT HO MANAGER' },
  { value: 'procurement_ho_staff', label: 'PROCUREMENT HO STAFF' },
  { value: 'operational_manager', label: 'OPERATIONAL MANAGER' },
  { value: 'operational_staff', label: 'OPERATIONAL STAFF' },
  { value: 'finance_manager', label: 'FINANCE MANAGER' },
  { value: 'finance_staff', label: 'FINANCE STAFF' },
  { value: 'accounting', label: 'ACCOUNTING / RELEASER' },
  { value: 'gs', label: 'GENERAL SUPPORT (GS)' },
];

export const COMMERCIAL_ROLES = ['commercial_manager', 'commercial_staff'];
export const ADMIN_ROLES = ['admin', 'Director', 'director'];

// Roles that see all projects on the dashboard but cannot open /projects.
export const BACK_OFFICE_ROLES = [
  'staff',
  'procurement_ho_manager', 'procurement_ho_staff',
  'operational_manager', 'operational_staff',
  'finance_manager', 'finance_staff',
  'accounting',
  'gs',
];

export const isCommercialRole = (role) => COMMERCIAL_ROLES.includes(role);
export const isAdminRole = (role) => ADMIN_ROLES.includes(role);
export const isBackOfficeRole = (role) => BACK_OFFICE_ROLES.includes((role || '').toLowerCase());
